<nav class="breadcrumb container-fluid">
  <ol class="breadcrumb">
    <!-- Iterate through breadcrumbs -->
    @for (breadcrumb of breadcrumbs; track breadcrumb; let last = $last; let i = $index) {
      <!-- Add a separator before all but the first item -->
      @if (i > 0) {
        <span class="breadcrumb-separator"> / </span>
      }
      <li class="breadcrumb-item" [ngClass]="{ active: last }">
        @if (!last) {
          <a [routerLink]="breadcrumb.url">{{ breadcrumb.label }}</a>
        }
        @if (last) {
          <span class="breadcrumb-current">{{ breadcrumb.label }}</span>
        }
      </li>
    }
  </ol>
</nav>
